import { render, staticRenderFns } from "./LanguageSelection.vue?vue&type=template&id=3c0accba&scoped=true&"
import script from "./LanguageSelection.vue?vue&type=script&lang=js&"
export * from "./LanguageSelection.vue?vue&type=script&lang=js&"
import style0 from "./LanguageSelection.vue?vue&type=style&index=0&id=3c0accba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0accba",
  null
  
)

export default component.exports